<template>
  <div
    :id="uuid"
    class="p-6 md:p-8 bg-white rounded-xl"
    style="scroll-margin-top: calc(4rem + env(safe-area-inset-top))"
  >
    <div
      class="grid gap-4"
      :class="`grid-cols-1 md:grid-cols-${formData.colsNumberOnDesktop || 2}`"
    >
      <template v-for="(column, index) in formData.columns" :key="index">
        <div
          class="marked flex-1"
          :style="{ color: column.textColor }"
          v-html="getMarkedTextWithBlankLinks(column.text)"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
interface FormDataInterface {
  columns: {
    text: string
    textColor: string
  }[]
  colsNumberOnDesktop?: number
}

interface PropsInterface {
  uuid: string
  formData: FormDataInterface
}

defineProps<PropsInterface>()

const { getMarkedTextWithBlankLinks } = useMarkedText()
</script>
